import { ADOPTAFRICA } from "../../../../config/configs";
import ROUTES from "../../../../config/routes";

export const FOOTER_LINKS = [
    {
        heading: 'Company',
        links: [
        { label: 'About',    path: ROUTES.ABOUT },
        { label: 'Our Work', path: ROUTES.WORK },
        { label: 'Robotics', path: ROUTES.ROBOTICS },
        { label: 'Contact',  path: ROUTES.CONTACT },
        ],
    },
    {
        heading: 'Services',
        links: [
        { label: 'Custom Software',    path: ROUTES.SERVICES },
        { label: 'AI & Automation',    path: ROUTES.SERVICES },
        { label: 'Mobile Apps',        path: ROUTES.SERVICES },
        { label: 'M-Pesa Integration', path: ROUTES.SERVICES },
        ],
    },
    {
        heading: 'Products',
        links: [
        { label: ADOPTAFRICA,     path: '/' },
        { label: 'Book a Strategy Session', path: ROUTES.CONTACT },
        ],
    },
    {
        heading: 'Legal',
        links: [
        { label: 'Privacy Policy',  path: ROUTES.PRIVACY },
        { label: 'Terms of Service', path: ROUTES.TERMS },
        { label: 'Cookie Policy',   path: ROUTES.COOKIES },
        ],
    },
];